import React, { useState } from 'react'
import { CustomSnackbarContext } from './context'

export const CustomSnackbarProvider = ({ children }) => {
  const [snackbarMessage, setSnackbarMessage] = useState('')

  return (
    <CustomSnackbarContext.Provider
      value={{
        snackbarMessage,
        setSnackbarMessage,
      }}
    >
      {children}
    </CustomSnackbarContext.Provider>
  )
}
